export const fetchISEMappingTemplates = async (
  endpoint: string,
  productId: string,
  token: string,
): Promise<IISEFieldMapGetTemplateResponse | null> => {
  const path = 'product/config'
  const query = new URLSearchParams({
    productName: productId,
  })
  const response = await fetch(`${endpoint}/${path}?${String(query)}`, {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    console.error('Error fetching field mapping template.')
    return null
  }

  return await response.json()
}

export const pushFieldMapping = async (
  endpoint: string,
  accountId: string,
  productId: string,
  token: string,
  payload: any,
) => {
  const path = `account/products/${accountId}/${productId}`
  const response = await fetch(`${endpoint}/${path}`, {
    method: 'PUT',
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    console.error('Error pushing field mapping configuration.')
    return false
  }

  return true
}
